const FieldTypes = {
  TEXT: "text",
  CHECKBOX: "checkbox",
  RADIO: "radio",
  TEXTAREA: "textarea"
};
export {
  FieldTypes
};
//# sourceMappingURL=constants.mjs.map
